import { styled } from '@mui/material/styles';
import { Divider, ListItem } from '@mui/material';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import { Link } from 'react-router-dom';

export const ItemLayout = styled('div')(() => ({
  display: 'flex',
  gap: 16,
  width: '100%'
}));

export const NotificationInfoCtn = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  flex: '1 auto',
  gap: 4
}));

export const NotificationActions = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center'
}));

export const DateText = styled('div')(() => ({
  fontWeight: 500,
  fontSize: 14
}));

// Styled ListItem with hover effect and read/unread styling
export const StyledListItem = styled(ListItem)(({ isRead }) => ({
  '&:hover': {
    backgroundColor: '#EEE'
  },
  color: isRead ? '#828282' : 'inherit'
}));

export const UnreadDotIcon = styled(FiberManualRecordIcon)(() => ({
  color: '#f44336',
  fontSize: 12,
  marginRight: 2,
  maxWidth: 12,
  maxHeight: 12
}));

export const NotificationIconContainer = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center'
}));

export const StyledDivider = styled(Divider)(() => ({
  height: 2
}));

export const NotificationLink = styled(Link)(() => ({
  color: 'inherit',
  borderBottom: '1px #000000de solid',
  paddingBottom: 1,
  textDecoration: 'none',
  '&:hover': {
    borderBottom: 0,
    cursor: 'pointer'
  }
}));

export const DescriptionItem = styled('div')(() => ({
  fontSize: 14
}));

export const AlertIcon = styled(NotificationsActiveIcon)({
  color: '#FF4635'
});
